import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    lastQuery: null,
    tradingAreaList: [],
};

const mutations = {
    [type.SET_TRADING_AREA_LIST](state, trading_area) {
        state.tradingAreaList = trading_area;
    },

    [type.ADD_TRADING_AREA](state, trading_area) {
        state.tradingAreaList.push(trading_area);
    },
};

const getters = {
    trading_areas(state) {
        return state.tradingAreaList;
    },
};

const actions = {
    getTradingAreas({ commit }, params) {
        let route = Laroute.route('franchise.vue.trading_area');

        let options = {
            params: _.merge(
                {
                    limit: 10,
                    query: null,
                },
                params,
            ),
        };

        axios.get(route, options).then(res => {
            commit(type.SET_TRADING_AREA_LIST, res.data.data);
        });
    },

    getTradingArea({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.trading_area.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-trading-area');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-trading-area');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-trading-area');
                throw err;
            });
    },

    getTradingAreaListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.tradingAreaList.length || state.lastQuery !== params.query) {
            return dispatch('getTradingAreas', params);
        }

        return Promise.resolve(state.tradingAreaList);
    },

    updateTradingArea({ commit, dispatch }, trading_area) {
        let route = Laroute.route('franchise.trading_area.update', {
            id: trading_area.id,
        });
        startLoading(dispatch, 'save-trading-area');

        return axios
            .patch(route, trading_area)
            .then(res => {
                endLoading(dispatch, 'save-trading-area');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-trading-area');
                throw err;
            });
    },

    createTradingArea({ commit, dispatch }, trading_area) {
        let route = Laroute.route('franchise.trading_area.store');
        startLoading(dispatch, 'save-trading-area');

        return axios
            .post(route, trading_area)
            .then(res => {
                commit(type.ADD_TRADING_AREA, res.data);
                endLoading(dispatch, 'save-trading-area');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-trading-area');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
